import React from 'react';
import foodMenu1 from '../assets/images/food-menu1.png';
import foodMenu2 from '../assets/images/food-menu2.png';
import drinksMenu1 from '../assets/images/drinks-menu1.png';
import drinksMenu2 from '../assets/images/drinks-menu2.png';
import lunchMenu from '../assets/images/lunch-menu.jpg';

const Menu: React.FC = () => {
  return (
    <div className="bg-white min-h-screen">
      <div className="max-w-[1440px] mx-auto px-4 sm:px-6 md:px-8 py-12 md:py-16">
        {/* A LA CARTE MENU */}
        <h1
          className="font-teko font-semibold text-[32px] sm:text-[40px] md:text-[48px] leading-tight"
          style={{ color: '#0B5C33' }}
        >
          A LA CARTE MENU
        </h1>
        <div className="w-full h-px bg-black mb-8 md:mb-12"></div>

        <div className="flex flex-col gap-6 md:gap-10 mb-12 md:mb-16">
          <div className="w-full overflow-hidden">
            <img
              src={foodMenu1}
              alt="A La Carte Menu 1"
              className="w-full h-auto object-contain"
            />
          </div>
          <div className="w-full overflow-hidden">
            <img
              src={foodMenu2}
              alt="A La Carte Menu 2"
              className="w-full h-auto object-contain"
            />
          </div>
        </div>

        {/* DRINKS MENU */}
        <h2
          className="font-teko font-semibold text-[32px] sm:text-[40px] md:text-[48px] leading-tight"
          style={{ color: '#0B5C33' }}
        >
          DRINKS MENU
        </h2>
        <div className="w-full h-px bg-black mb-8 md:mb-12"></div>

        <div className="flex flex-col sm:flex-row gap-6 md:gap-10 mb-12 md:mb-16">
          <div className="w-full sm:w-1/2 overflow-hidden">
            <img
              src={drinksMenu1}
              alt="Drinks Menu 1"
              className="w-full h-auto object-contain"
            />
          </div>
          <div className="w-full sm:w-1/2 overflow-hidden">
            <img
              src={drinksMenu2}
              alt="Drinks Menu 2"
              className="w-full h-auto object-contain"
            />
          </div>
        </div>

        {/* LUNCH MENU */}
        <h2
          className="font-teko font-semibold text-[32px] sm:text-[40px] md:text-[48px] leading-tight"
          style={{ color: '#0B5C33' }}
        >
          LUNCH MENU - 12:00 PM to 4:00 PM
        </h2>
        <div className="w-full h-px bg-black mb-8 md:mb-12"></div>

        <div className="flex justify-center mb-12 md:mb-16">
          <div className="w-full max-w-[725px] overflow-hidden">
            <img
              src={lunchMenu}
              alt="Lunch Menu"
              className="w-full h-auto object-contain"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Menu;
